import { isSameDay, startOfWeek } from '../../../../../helpers/date'
import { LeaveOfAbsencesOverviewHeadWeek } from './LeaveOfAbsencesOverviewHeadWeek'

export const transformToLeaveOfAbsencesOverviewHeadWeek = (date: Date): LeaveOfAbsencesOverviewHeadWeek => ({
    id: date.getTime().toString(),
    date: isSameDay(startOfWeek(date, { weekStartsOn: 1 }), date) ? date : undefined,
})
